import generatedCatalog from "./cityDecorationCatalog.generated.json";

const normalizeEffect = (effect = {}) => {
  const effectId = Math.trunc(Number(effect?.effectId || 0));
  const value = Number(effect?.value || 0);
  if (!Number.isFinite(effectId) || effectId <= 0 || !Number.isFinite(value) || value === 0) return null;
  return { effectId, value };
};

const normalizeLevel = (level = {}) => ({
  level: Math.max(0, Math.floor(Number(level?.level || 0))),
  levelLabel: String(level?.levelLabel || "").trim(),
  decorationUnlockGid: Math.trunc(Number(level?.dec_gid || level?.debug?.raw?.dec_gid || 0)) || null,
  durationSeconds: Math.floor(Number(level?.durationSeconds || 0)),
  durationLabel: String(level?.durationLabel || "").trim(),
  quality: Math.max(0, Math.floor(Number(level?.quality || 0))),
  power: Math.max(0, Math.floor(Number(level?.power || 0))),
  effects: (Array.isArray(level?.effects) ? level.effects : []).map(normalizeEffect).filter(Boolean),
  costs: Array.isArray(level?.costs) ? level.costs : [],
});

const normalizeDecoration = (row = {}, levelKey = "levels") => ({
  id: Math.trunc(Number(row?.decorationId ?? row?.id ?? row?.itemGid ?? 0)),
  decorationId: Math.trunc(Number(row?.decorationId ?? row?.id ?? row?.itemGid ?? 0)),
  itemGid: Math.trunc(Number(row?.itemGid || 0)),
  name: String(row?.name || "").trim(),
  label: String(row?.name || "").trim(),
  category: String(row?.category || "").trim(),
  categoryLabel: String(row?.categoryLabel || "").trim(),
  description: String(row?.description || "").trim(),
  iconKey: String(row?.iconKey || "").trim(),
  parentDecorationId: Math.trunc(Number(row?.parentDecorationId || 0)) || null,
  parentName: String(row?.parentName || "").trim(),
  sourceTable: String(row?.sourceTable || "").trim(),
  guardGid: Math.trunc(Number(row?.guardGid || 0)) || null,
  guardCode: Math.trunc(Number(row?.guardCode || 0)) || null,
  rank: Math.trunc(Number(row?.rank || 0)) || null,
  [levelKey]: (Array.isArray(row?.[levelKey]) ? row[levelKey] : []).map(normalizeLevel),
  effects: (Array.isArray(row?.effects) ? row.effects : []).map(normalizeEffect).filter(Boolean),
});

export const CITY_DECORATION_PERMANENT_OPTIONS = Array.isArray(generatedCatalog?.permanentDecorations)
  ? generatedCatalog.permanentDecorations
    .map((row) => normalizeDecoration(row, "levels"))
    .filter((row) => row.id > 0 && row.name && row.levels.some((level) => level.effects.length > 0))
  : [];

export const CITY_DECORATION_TEMPORARY_BUFFS = Array.isArray(generatedCatalog?.temporaryBuffDecorations)
  ? generatedCatalog.temporaryBuffDecorations
    .map((row) => normalizeDecoration(row, "durationOptions"))
    .filter((row) => row.itemGid > 0 && row.name && row.effects.length > 0)
  : [];

const CITY_DECORATION_CATALOG = {
  permanentDecorations: CITY_DECORATION_PERMANENT_OPTIONS,
  temporaryBuffDecorations: CITY_DECORATION_TEMPORARY_BUFFS,
};

export default CITY_DECORATION_CATALOG;
